<div id="app" class="app app-content-full-height app-without-sidebar app-without-header">
  <div id="content" class="app-content p-0">
    <div class="pos pos-vertical pos-with-sidebar pos-mobile-sidebar-toggled" id="pos">
      <div class="pos-container">

        <app-header></app-header>

        <ng-container *ngIf="!isMobile">
          <div class="d-flex">
            <div class="d-flex flex-row flex-wrap " style="height: fit-content;">
              <span class="h5 w-100 mb-3">Select payment method</span>
              <button class="btn btn-lg me-2 mb-2 bg-white h-55px shadow shadow-sm"
                      style="width: 32%;"
                      matRipple
                      [ngClass]="{'btn-outline-warning border-3': selectedPaymentMethod.id === item.id}"
                      *ngFor="let item of paymentMethods"
                      (click)="changePaymentMethod(item)">
                <div class="d-flex flex-row align-items-center justify-content-center px-1">
                  <div class="w-30px me-2 text-center" *ngIf="item?.logoUrl">
                    <img src="{{item?.logoUrl}}" alt="" class="w-30px">
                  </div>
                  <div class="w-30px me-2 text-center" *ngIf="!item?.logoUrl">
                    <i [class]="getPaymentMethodIcon(item?.category)" style="font-size: 1.3rem;"></i>
                  </div>
                  <span class="text-primary text-left w-135px d-block " style="min-width: fit-content">{{item.name}}</span>
                </div>
              </button>

<!--              isMembership-->
              <ng-container *ngIf="membership">
                <div class="d-flex flex-row flex-wrap mt-4 w-100" style="height: fit-content;">
                  <span class="h5 w-100 mb-3">Cashback Redeems</span>

                  <mat-card class="membership-card mt-2"  [ngClass]="{'cashback-select': membershipRedeemPoint > 0}"
                            (click)="openMembershipRedeemDialog() ">
                    <mat-card-content class="d-flex align-items-center">
                      <div class="symbol-circle me-1">F</div>
                      <div class="ml-3">
                        <div class="font-weight-bold">{{membership?.name}} ({{membership?.phoneNo}})</div>
                        <div class="text-muted">Available cashback: <span class="text-green">RM {{membership?.availablePoints | number: '1.2-2' }}</span></div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </div>
              </ng-container>


              <ng-container *ngIf="isCash()">
                <div class="d-flex flex-row flex-wrap mt-4 w-100" style="height: fit-content;">
                  <span class="h5 w-100 mb-3">Quick Pay</span>
                  <button class="btn btn-lg me-2 mb-2 bg-white h-55px shadow shadow-sm"
                          style="width: 32%;"
                          matRipple
                          *ngFor="let item of bankNotes"
                          [ngClass]="{'btn-outline-warning border-3': selectedBankNote === item}"
                          (click)="changeBankNote(item)">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                      <span class="text-primary text-left">{{item.name}}</span>
                    </div>
                  </button>

                  <button class="btn btn-lg me-2 mb-2 bg-white h-55px shadow shadow-sm"
                          style="width: 32%;"
                          matRipple
                          (click)="displayCalculator('cash')">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                      <div class="text-primary text-left d-block" style="min-width: fit-content"><i class="fa-solid fa-cash-register me-2"></i> Enter Cash <span *ngIf="paidAmount">({{paidAmount}})</span></div>
                    </div>
                  </button>
                </div>
              </ng-container>

              <ng-container>
                <div class="d-flex flex-row flex-wrap mt-4 w-100" style="height: fit-content;">
                  <span class="h5 w-100 mb-3">Quick Action</span>
                  <button class="btn btn-lg me-2 mb-2 bg-white h-55px shadow shadow-sm"
                          style="width: 32%;"
                          matRipple
                          (click)="displayDiscountDialog()">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                      <div class="text-primary text-left"><i class="fa-solid fa-percent me-2"></i> Discount <span *ngIf="discountPercentage">({{discountPercentage}}%)</span></div>
                    </div>
                  </button>

                  <button class="btn btn-lg me-2 mb-2 bg-white h-55px shadow shadow-sm"
                          style="width: 32%;"
                          matRipple
                          (click)="displayCalculator('tips')">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                      <span class="text-primary text-left"><i class="fa-solid fa-coins me-2"></i> Tips <span *ngIf="tipsAmount">({{tipsAmount | currencyDisplay}})</span></span>
                    </div>
                  </button>

                </div>
              </ng-container>

            </div>

            <!--          payment summary-->
            <div class="d-flex flex-column col-5 align-items-center">
              <div class="w-90 mb-3">
              <span class="h5 w-100">Payment Summary</span>
              </div>
              <div class="bg-white p-3 rounded w-90 h-450px d-flex flex-column justify-content-between">
                <table class="w-100 table-striped bg-white">
                  <tr *ngIf="shouldShowReferenceNo()">
                    <td>
                      <h6 class="text-dark-500">Reference No</h6>
                    </td>
                    <td>
                      <input #referenceNoRef type="text" [(ngModel)]="referenceNo" class="px-2 w-100 rounded">
                      <span class="text-danger" *ngIf="errMsg">{{errMsg}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 class="text-dark-500">Sub Total</h6>
                    </td>
                    <td>
                      <h6 class="text-right
                    ">RM {{ subtotal | currencyDisplay }}
                      </h6>
                    </td>
                  </tr>

                  <tr *ngIf="discountAmount > 0">
                    <td>
                      <h6 class="text-muted">Discount ({{ discountPercentage }}%)</h6>
                    </td>
                    <td>
                      <h6 class="text-muted text-right">
                        RM -{{ discountAmount | currencyDisplay }}
                      </h6>
                    </td>
                  </tr>
                  <tr *ngIf="chargesAmount > 0">
                    <td>
                      <h6 class="text-muted">Delivery Charge</h6>
                    </td>
                    <td>
                      <h6 class="text-muted text-right
                    ">RM {{ chargesAmount | currencyDisplay }} ({{ chargesPercent }}%)
                      </h6>
                    </td>
                  <tr *ngIf="tax1Amount > 0">
                    <td>
                      <h6 class="text-muted">SST</h6>
                    </td>
                    <td>
                      <h6 class="text-muted text-right">
                        RM {{ tax1Amount | currencyDisplay }}</h6>
                    </td>
                  </tr>
                  <tr *ngIf="tax2Amount > 0">
                    <td>
                      <h6 class="text-muted">Serv. Charge</h6>
                    </td>
                    <td>
                      <h6 class="text-muted text-right">
                        RM {{ tax2Amount | currencyDisplay }}
                      </h6>
                    </td>
                  </tr>
                  <tr *ngIf="discountItemAmount > 0">
                    <td>
                      <h6 class="text-muted">Item Discount</h6>
                    </td>
                    <td>
                      <h6 class="text-muted text-right">
                        RM -{{ discountItemAmount | currencyDisplay }}
                      </h6>
                    </td>
                  </tr>
                  <tr *ngIf="membership && membershipRedeemPoint > 0">
                    <td>
                      <h6 class="text-muted">Cashback</h6>
                    </td>
                    <td>
                      <h6 class="text-muted text-right">
                        RM -{{ membershipRedeemPoint | currencyDisplay }}
                      </h6>
                    </td>
                  </tr>
                  <tr *ngIf="staffMealAmount > 0">
                    <td>
                      <h6 class="text-success">Staff Meal</h6>
                    </td>
                    <td>
                      <h6 class="text-success text-right">
                        RM -{{ staffMealAmount | currencyDisplay }}
                      </h6>
                    </td>
                  </tr>
                  <tr *ngIf="voucherAmount > 0">
                    <td>
                      <h6 class="text-warning mb-0">Voucher ({{ voucherData?.voucher?.code }})
                        <a class="text-danger ml-2" style="cursor: pointer; font-size: 12px;" (click)="clearVoucher()">
                          <i class="fa fa-times-circle"></i> Remove
                        </a>
                      </h6>
                    </td>
                    <td><h6 class="text-warning text-right mb-0">- RM {{ voucherAmount | number:'1.2-2' }}</h6></td>
                  </tr>
                  <tr *ngIf="tipsAmount > 0">
                    <td>
                      <h6 class="text-muted">Tips</h6>
                    </td>
                    <td>
                      <h6 class="text-muted text-right">
                        RM {{ tipsAmount | currencyDisplay }}
                      </h6>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 class="text-muted">Rounding</h6>
                    </td>
                    <td>
                      <h6 class="text-muted text-right">
                        RM {{ roundingAmount | currencyDisplay }}
                      </h6>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="100%">
                      <hr class="text-muted" style="border-top: 1px dashed">
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h5 class="text-dark-500">Total</h5>
                    </td>
                    <td>
                      <h5 class="text-right">
                        RM {{ getToBePaidTotal() | currencyDisplay }}
                      </h5>
                    </td>
                  </tr>
                  <tr *ngIf="inclusiveTax > 0">
                    <td colspan="99">
                      <h6 class="fst-italic text-muted">
                        (Inclusive of 6% SST: RM{{ inclusiveTax | currencyDisplay }})
                      </h6>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <h6 class="text-blue-700">Cash Received</h6>
                    </td>
                    <td>
                      <h6 class="text-blue-700 text-right">
                        RM {{ paidAmount | currencyDisplay }}
                      </h6>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <h6 class="text-muted">Change</h6>
                    </td>
                    <td>
                      <h6 class="text-muted text-right">
                        RM {{ ((paidAmount - (getToBePaidTotal())) || 0) | currencyDisplay }}
                      </h6>
                    </td>
                  </tr>
                </table>

                <div class="d-flex w-100 justify-content-center mt-3">

                  <div class="col-4 me-2">
                    <button class="btn btn-lg btn-default fw-semibold mb-0 d-block py-3 w-100" (click)="back()">Cancel
                    </button>
                  </div>

                  <div class="col-8" role="button">
                    <button
                      class="btn btn-lg text-white bg-primary text-white border-0 fw-semibold d-flex justify-content-center align-items-center py-3 m-0 w-100"
                      (click)="submit()"
                      [disabled]="isDisabled() || loading.submitting">
                      <i class="fa fa-credit-card ms-2 me-2"></i>
                      Pay
                    </button>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isMobile">
          <div class="container-fluid" style="padding-top: 10px">
            <div class="row">
              <!-- Payment Methods Section -->
              <div class="col-12 col-md-6 mb-3">
                <span class="h6 w-100 mb-3 d-block">Select payment method</span>
                <div class="d-flex flex-wrap justify-content-between">
                  <button class="btn btn-lg me-3 mb-2 col-5 bg-white h-55px"
                          matRipple
                          [ngClass]="{'btn-outline-warning border-3': selectedPaymentMethod.id === item.id}"
                          *ngFor="let item of paymentMethods"
                          (click)="changePaymentMethod(item)">
                    <div class="d-flex flex-row align-items-center justify-content-center px-1">
                      <div class="w-30px me-2 text-center" *ngIf="item?.logoUrl">
                        <img src="{{item?.logoUrl}}" alt="" class="w-30px">
                      </div>
                      <div class="w-30px me-2 text-center" *ngIf="!item?.logoUrl">
                        <i [class]="getPaymentMethodIcon(item?.category)" style="font-size: 1.3rem;"></i>
                      </div>
                      <span class="text-primary text-left w-135px" style="font-size: 0.9rem;">{{item.name}}</span>
                    </div>
                  </button>

                  <!--              isMembership-->
                  <ng-container *ngIf="membership">
                    <div class="d-flex flex-row flex-wrap mt-4 w-100" style="height: fit-content;">
                      <span class="h5 w-100 mb-3">Cashback Redeems</span>

                      <mat-card class="membership-card"  [ngClass]="{'cashback-select': membershipRedeemPoint > 0}"
                                (click)="openMembershipRedeemDialog() ">
                        <mat-card-content class="d-flex align-items-center">
                          <div class="symbol-circle me-1">F</div>
                          <div class="ml-3">
                            <div class="font-weight-bold">{{membership?.name}} ({{membership?.phoneNo}})</div>
                            <div class="text-muted">Available cashback: <span class="text-green">RM {{membership?.availablePoints | number: '1.2-2' }}</span></div>
                          </div>
                        </mat-card-content>
                      </mat-card>
                    </div>
                  </ng-container>
                </div>


                <ng-container *ngIf="isCash()">
                  <div class="d-flex flex-row flex-wrap mt-4 w-100" style="height: fit-content;">
                    <span class="h6 w-100 mb-3">Quick Pay</span>
                    <button class="btn btn-lg me-3 mb-2 col-5 bg-white h-55px"
                            matRipple
                            *ngFor="let item of bankNotes"
                            [ngClass]="{'btn-outline-warning border-3': selectedBankNote === item}"
                            (click)="changeBankNote(item)">
                      <div class="d-flex flex-row align-items-center justify-content-center">
                        <span class="text-primary text-left" style="font-size: 0.9rem;">{{item.name}}</span>
                      </div>
                    </button>
                  </div>
                </ng-container>

              </div>

              <!-- Payment Summary Section -->
              <div class="col-12 col-md-6">
                <span class="h6 w-100 mb-3 d-block">Payment Summary</span>
                <div class="bg-white col-12 d-flex flex-column justify-content-start pb-3 pt-3 px-4 rounded">
                  <div class="w-100">
                    <h5 style="font-size: 1rem;">Table: {{table?.name}}</h5>
                  </div>

                  <ng-container>

                    <div class="w-100 mt-3">
                      <h6 class="text-dark-400" style="font-size: 0.9rem;">
                        <i class="fa fa-cash-register me-3"></i>
                        <span>Sub Total</span>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <h4 class="mb-0 me-3" style="font-size: 1rem;">RM {{subtotal | currencyDisplay}}</h4>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="shouldShowReferenceNo()">
                    <div class="w-100 mt-3">
                      <h6 class="text-dark-400" style="font-size: 0.9rem;">{{ isStaffMeal() ? 'Staff No #' : 'Reference No #' }}</h6>
                      <input #referenceNoRef type="text" [(ngModel)]="referenceNo" class="p-2 h4 w-100 rounded" style="font-size: 1rem;">
                      <span class="text-danger" *ngIf="errMsg">{{errMsg}}</span>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="membership">
                    <div class="w-300px mt-3">
                      <h5 class="text-dark-400">
                        <i class="fas fa-gift me-3"></i>
                        <span>Cashback Redeems</span>
                      </h5>
                      <div class="d-flex justify-content-start align-items-center"
                           role="button">
                        <h3 class="mb-0 me-3 text-red-600">RM -{{membershipRedeemPoint | currencyDisplay}}</h3>

                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="staffMealAmount > 0">
                    <div class="w-100 mt-3">
                      <h6 class="text-dark-400" style="font-size: 0.9rem;">
                        <i class="fa fa-utensils me-3"></i>
                        <span>Staff Meal</span>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <h4 class="mb-0 me-3 text-green-600" style="font-size: 1rem;">RM -{{staffMealAmount | currencyDisplay}}</h4>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="voucherAmount > 0">
                    <div class="w-100 mt-3">
                      <h6 class="text-dark-400" style="font-size: 0.9rem;">
                        <i class="fa fa-tag me-3"></i>
                        <span>Voucher ({{ voucherData?.voucher?.code }})
                          <a class="text-danger ml-2" style="cursor: pointer; font-size: 12px;" (click)="clearVoucher()">
                            <i class="fa fa-times-circle"></i> Remove
                          </a>
                        </span>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <h4 class="mb-0 me-3 text-warning" style="font-size: 1rem;">RM -{{voucherAmount | number:'1.2-2'}}</h4>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="chargesAmount > 0">
                    <div class="w-100 mt-3">
                      <h6 class="text-dark-400" style="font-size: 0.9rem;">
                        <i class="fas fa-coins me-3"></i>
                        <span>Delivery Charge</span>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <h4 class="mb-0 me-3 text-green-600" style="font-size: 1rem;">RM {{chargesAmount | currencyDisplay}} ({{chargesPercent}}%)</h4>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="tax1Amount > 0">
                    <div class="w-100 mt-3">
                      <h6 class="text-dark-400" style="font-size: 0.9rem;">
                        <i class="fas fa-coins me-3"></i>
                        <span>SST</span>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center" role="button">
                        <h4 class="mb-0 me-3" style="font-size: 1rem;">RM {{tax1Amount | currencyDisplay}}</h4>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="tax2Amount > 0">
                    <div class="w-100 mt-3">
                      <h6 class="text-dark-400" style="font-size: 0.9rem;">
                        <i class="fas fa-coins me-3"></i>
                        <span>Service Charge</span>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center" role="button">
                        <h4 class="mb-0 me-3" style="font-size: 1rem;">RM {{tax2Amount | currencyDisplay}}</h4>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container>
                    <div class="w-100 mt-3">
                      <h6 class="text-dark-400" style="font-size: 0.9rem;">
                        <i class="fas fa-coins me-3"></i>
                        <span>Tips</span>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center" role="button" (click)="displayCalculator('tips')">
                        <h4 class="mb-0 me-3" style="font-size: 1rem;">RM {{tipsAmount | currencyDisplay}}</h4>
                        <i class="fa fa-calculator fs-20px"></i>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="discountItemAmount > 0">
                    <div class="w-100 mt-3">
                      <h6 class="text-dark-400" style="font-size: 0.9rem;">
                        <i class="fa fa-percentage me-3"></i>
                        <span>Discount Item</span>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center" role="button">
                        <h4 class="mb-0 me-3 text-red-600" style="font-size: 1rem;">RM -{{discountItemAmount | currencyDisplay}}</h4>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container>
                    <div class="w-100 mt-3">
                      <h6 class="text-dark-400" style="font-size: 0.9rem;">
                        <i class="fa fa-percentage me-3"></i>
                        <span>Discount</span>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center" role="button" (click)="displayDiscountDialog()">
                        <h4 class="mb-0 me-3 text-red-600" style="font-size: 1rem;">RM -{{discountAmount | currencyDisplay}} ({{discountPercentage}}%)</h4>
                        <i class="fa fa-calculator fs-20px"></i>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container>
                    <div class="w-100 mt-3">
                      <h6 class="text-dark-400" style="font-size: 0.9rem;">
                        <i class="fas fa-coins me-3"></i>
                        <span>Rounding</span>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center" role="button">
                        <h4 class="mb-0 me-3" style="font-size: 1rem;">RM {{roundingAmount | currencyDisplay}}</h4>
                      </div>
                    </div>
                  </ng-container>

                  <div class="w-100 mt-3">
                    <h6 class="text-dark-400" style="font-size: 0.9rem;">
                      <i class="fa fa-cash-register me-3"></i>
                      <span>Total Due</span>
                    </h6>
                    <h4 class="mb-0" style="font-size: 1rem;">RM {{getToBePaidTotal() | currencyDisplay}}</h4>
                  </div>

                  <ng-container>
                    <div class="w-100 mt-3">
                      <h6 class="text-dark-400" style="font-size: 0.9rem;">
                        <i class="far fa-credit-card me-3"></i>
                        <span>Cash Received</span>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center" role="button" (click)="displayCalculator('cash')">
                        <h4 #paidAmountRef class="mb-0 me-3 text-green-600" style="font-size: 1rem;">RM {{paidAmount | currencyDisplay}}</h4>
                        <i class="fa fa-calculator fs-20px"></i>
                      </div>
                    </div>
                  </ng-container>

                  <div class="w-100 mt-3">
                    <h6 class="text-dark-400" style="font-size: 0.9rem;">
                      <i class="fas fa-exchange-alt me-3"></i>
                      <span>Change</span>
                    </h6>
                    <h4 class="text-blue-700 mb-0" style="font-size: 1rem;">
                      RM {{((paidAmount - (getToBePaidTotal())) || 0) | currencyDisplay}}</h4>
                  </div>

                  <div class="row w-100 justify-content-center mt-3">
                    <div class="col-6 mb-2">
                      <button class="btn btn-lg btn-default fw-semibold mb-0 d-block py-3 w-100" (click)="back()">Cancel</button>
                    </div>
                    <div class="col-6 mb-2">
                      <button class="btn btn-lg btn-primary bg-green-600 text-white border-0 fw-semibold d-flex justify-content-center align-items-center py-3 m-0 w-100" (click)="submit()" [disabled]="isDisabled() || loading.submitting">
                        <i class="fa fa-credit-card ms-2 me-2"></i>
                        Pay
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </ng-container>
      </div>
    </div>
  </div>
</div>
